import { render, staticRenderFns } from "./concesion.vue?vue&type=template&id=10a126ba&scoped=true"
import script from "./concesion.vue?vue&type=script&lang=js"
export * from "./concesion.vue?vue&type=script&lang=js"
import style0 from "./concesion.vue?vue&type=style&index=0&id=10a126ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a126ba",
  null
  
)

export default component.exports